import { Diamond } from "lucide-react";

export default function Marquee({ items }) {
    const row = [...items, ...items, ...items, ...items];
    return (
        <div data-testid="editorial-marquee" className="relative overflow-hidden border-b border-white/5 py-5">
            <div className="flex w-max animate-marquee items-center gap-12 whitespace-nowrap">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center gap-12">
                        <span className="font-display text-xl sm:text-2xl font-medium text-ivory/30">{item}</span>
                        <Diamond size={9} className="text-glacier/50" fill="currentColor" />
                    </span>
                ))}
            </div>
        </div>
    );
}
